<div class="admin-content-header d-flex">
  <div class="title">
    <h1 class="header-title">طلبات القيود</h1>
  </div>
  <div ngbDropdown class="d-flex ml-auto">
    <div>
      <button [qcId]="'export-btn'" type="button" class="d-flex btn DS btn-outline-green ml-1 mr-1" id="dropdownBasic1"
        *ngIf="checkPermission('Pages.User.Default')" ngbDropdownToggle>
        <i class="fa-solid fa-file-arrow-down"></i>
        <span> إصدار تقرير </span>
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownBasic1" class="reports text-light"
        *ngIf="checkPermission('Pages.User.Default')">
        <button [qcId]="'export-excel'" (click)="exportAsExcel()" ngbDropdownItem>
          <i class="fa-regular fa-file-spreadsheet"></i>
          <span> إصدار بصيغة Excel</span>
        </button>
        <button [qcId]="'export-pdf'" (click)="exportAsPdf()" ngbDropdownItem>
          <i class="fa-solid fa-file-pdf"></i>
          <span>إصدار بصيغة PDF</span>
        </button>
      </div>
    </div>
  </div>
</div>

<nav aria-label="breadcrumb">
  <ol class="breadcrumb">
    <li class="breadcrumb-item">
      <a>
        <i class="d-inline-block fa-regular fa-house-blank"></i>
        <span> الرئيسية</span>
      </a>
    </li>
    <li class="breadcrumb-item active" aria-current="page">طلبات القيود</li>
  </ol>
</nav>

<div class="table-content">
  <div class="table-content-header">
    <div
      class="d-flex flex-column flex-md-row justify-content-center justify-content-md-end align-items-sm-center align-items-start pl-4 pr-4 pt-4 pb-4">
      <div>
        <div class="customCount">
          <span [qcId]="'totalcount-span'" class="count-number text-black">{{
            gridView.totalCount
            }}</span>
          <span class="count-title">طلبات القيود</span>
        </div>
      </div>
      <div class="ml-auto">
        <div class="input-group search-group">
          <input [qcId]="'search-btn'" type="text" #inputRef class="form-control" [(ngModel)]="this.searchModel.KeyWord"
            placeholder="بحث برقم الطلب و الرقم الوطنى الموحد للمنشأة " (focus)="onFocus()" (blur)="onBlur()"
            (keyup.enter)="refresh(1)" />
        </div>
      </div>
      <div>
        <div ngbDropdown #dropdown="ngbDropdown" class="filter filter-critria">
          <button type="button" class="btn btn-outline-secondary search" id="dropdownConfig" ngbDropdownToggle>
            <i class="fa-solid fa-bars-filter"></i>
            <span>تصفية</span>
          </button>
          <div ngbDropdownMenu aria-labelledby="dropdownConfig">
            <app-donor-request-admin-filter #filter [searchModel]="this.searchModel" (model)="filterData($event)">
            </app-donor-request-admin-filter>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="table-responsive">
    <table class="table table-hover">
      <thead>
        <tr>
          <th scope="col">{{ "AdminDonorRequest.ReqNo" | translate }}</th>
          <th scope="col">{{ "AdminDonorRequest.toCRName" | translate }}</th>
          <th scope="col">{{ "AdminDonorRequest.fromCRName" | translate }}</th>
          <th scope="col">{{ "AdminDonorRequest.requestDate" | translate }}</th>
          <th scope="col">{{ "AdminDonorRequest.requestType" | translate }}</th>
          <th scope="col">
            {{ "AdminDonorRequest.requestStatus" | translate }}
          </th>
        </tr>
      </thead>
      <tbody>
        <tr *ngIf="gridView?.items?.length === 0">
          <td class="text-center" colspan="8">
            <span><b>{{ "Global.NoResult" | translate }}</b></span>
          </td>
        </tr>
        <tr *ngFor="let res of gridView.items">
          <td>{{ res?.id }}</td>
          <td class="record">
            <p class="record-name">
              {{ res?.fromCRName }}
            </p>
            <span class="record-number text-grey">
              الرقم الوطنى الموحد للمنشأة: {{ res?.fromCRNumber }}</span>
          </td>
          <td class="record">
            <p class="record-name">
              {{ res?.toCRName }}
            </p>
            <span class="record-number text-grey">
              الرقم الوطنى الموحد للمنشأة:
              {{ res?.toCRNumber }}</span>
          </td>
          <td>{{ res?.creationDateString }}</td>
          <td>{{ res?.requestType }}</td>
          <td>{{ res?.requestStatus }}</td>
        </tr>
      </tbody>
    </table>
    <div class="table-content-footer">
      <div class="d-flex justify-content-between p-2">
        <div class="show-results d-flex align-items-center">
          <span>اظهر </span>
          <select class="form-select form-control" [(ngModel)]="pageSize" (ngModelChange)="onPageSizechange()">
            <option [ngValue]="10">10</option>
            <option [ngValue]="20">20</option>
            <option [ngValue]="50">50</option>
            <option [ngValue]="100">100</option>
          </select>
          <span>نتائج</span>
        </div>
        <ngb-pagination [collectionSize]="gridView?.totalCount" [(page)]="gridView.pageNumber"
          [pageSize]="gridView.pageSize" [maxSize]="10" (pageChange)="refresh($event)" [rotate]="true"
          [boundaryLinks]="true">
        </ngb-pagination>
      </div>
    </div>
  </div>
</div>